module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921025651_T.6696f64b.jpg";